import React from 'react'

import type { SpaceProps } from '../../../../themes'
import { Container, Item } from './styles'

export interface CardContentIconListProps extends SpaceProps {
  className?: string
  as?: 'div' | 'address'
  items: {
    icon: React.ReactNode
    text: React.ReactNode
  }[]
}

export const CardContentIconList = ({
  className,
  items,
  as = 'div',
  ...spaceProps
}: CardContentIconListProps) => (
  <Container className={className} as={as} {...spaceProps}>
    {items.map(({ icon, text }, i) => (
      <Item key={i}>
        {icon}
        {text}
      </Item>
    ))}
  </Container>
)
